import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { LoginMenuComponent } from './login-menu/login-menu.component';

export const components: any[] = [NavMenuComponent, LoginMenuComponent];

export * from './nav-menu/nav-menu.component';
export * from './login-menu/login-menu.component';
